import { render, staticRenderFns } from "./DictValueForm.vue?vue&type=template&id=7b9ea0c3"
import script from "./DictValueForm.vue?vue&type=script&lang=js"
export * from "./DictValueForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports